export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

export function safeJson(value: unknown): string {
  try {
    return JSON.stringify(value, null, 2) ?? String(value)
  } catch {
    return String(value)
  }
}

export function shortJson(value: unknown, maximumLength = 110): string {
  const json = safeJson(value).replace(/\s+/g, ' ')
  return json.length > maximumLength
    ? `${json.slice(0, maximumLength)}...`
    : json
}
